import { listContacts } from '../../graphql/queries';
import api from '../../services/api';
import debug from '../../services/debug';
import {
  SET_CONTACTID_ACTION_REQUESTED,
  SET_CONTACTID_ACTION_COMPLETED,
  SET_CONTACTID_ACTION_FAILED,
} from './types';

const setContactFromRouteAction = async (ContactID) => async (dispatch) => {
  dispatch({
    type: SET_CONTACTID_ACTION_REQUESTED,
  });

  try {
    const { data } = await api.graphql({
      query: listContacts,
      variables: {
        Search: ContactID,
      },
    });

    if (data.listContacts.items.length > 0) {
      dispatch({
        type: SET_CONTACTID_ACTION_COMPLETED,
        payload: data.listContacts,
      });
    }
  } catch (err) {
    debug(SET_CONTACTID_ACTION_FAILED, err);

    dispatch({
      type: SET_CONTACTID_ACTION_FAILED,
      payload: err,
    });
  }
};

export default setContactFromRouteAction;
